export default __webpack_public_path__ + "static/media/spirals-no-1.2ed6706e.mid";